import React, { Component } from 'react';
import localize from '../localize';
import { scoreBracket } from '../../utils/score_meta';
import './Leaderboard.css';
import ReactTooltip from 'react-tooltip';
import Location from '../Location';
import StatsTable from '../StatsTable';
import statsTracker from '../../utils/stats_tracker';
import getIspData from '../../utils/get_isp_data';
import { sortIsps } from '../../store/reducers/utils';

export const IspTipBare = ({ i18n, isp, timeWindow }) => (
  <div>
    <strong className="uppercase">{i18n.t('pages.scores.leaderboard.score_breakdown', false)}</strong><br />
    <StatsTable ethernetStats={getIspData(isp.stats, timeWindow).stats_ethernet} wirelessStats={getIspData(isp.stats, timeWindow).stats_wireless} showScores={true} />
  </div>
);

const IspTip = localize('metrics')(IspTipBare);

const Isp = localize('pages.scores.leaderboard')(({ i18n, isp, activeIsp, timeWindow }) => {
  const isSelected = activeIsp && isp.name === activeIsp.name;

  const score = getIspData(isp.stats, timeWindow).stats_ethernet && getIspData(isp.stats, timeWindow).stats_ethernet.player_games > 0 ?
        getIspData(isp.stats, timeWindow).stats_ethernet.connection_score : getIspData(isp.stats, timeWindow).stats_wireless.connection_score;

  const tipId = `isp-${isp.id}`;

  return (
    <tr className={`${scoreBracket(score)} ${isSelected ? 'selected' : ''}`}>
     <td className="ispName">
       <span className="isp-name-text">{isp.name}</span>
       <br />
       <span className="isp-percent">{ i18n.percent(getIspData(isp.stats, timeWindow).stats_overall.population) } { i18n.t('player_percent') }</span>
     </td>
     <td className="ispScore">
       <div data-tip data-for={tipId}>
         <div className={`leaderboard-score-number score-${scoreBracket(score)}`}>{score}</div>
         <ReactTooltip id={tipId} effect='solid' place='left' type='light'>
           <IspTip isp={isp} timeWindow={timeWindow} />
         </ReactTooltip>
       </div>
     </td>
   </tr>
  );
});

export const IspList = ({ isps, activeIsp, timeWindow }) => {
  const ispList = isps.map((isp) => <Isp isp={isp} activeIsp={activeIsp} key={isp.name} timeWindow={timeWindow} />);
  return (<tbody className="isps">
            {ispList}
          </tbody>);
};

class LeaderBoardBare extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemsVisible: Math.min(5, props.location.isps.length),
      sortBy: 'connection_score'
    }
  }

  handleLoadMore() {
    statsTracker.trackEvent('click', 'load_more_isps');
    this.setState({
      itemsVisible: Math.min(this.state.itemsVisible + 5, this.props.location.isps.length)
    });
  }

  handleSort() {
    this.setSort(this.toggle.getAttribute('state') === 'off' ? 'connection_score' : 'population');
  }

  setSort(sortBy) {
    this.setState({
      sortBy
    });
  }

  filterIsps() {
    const { sortBy } = this.state;
    const { timeWindow } = this.props;
    let isps = sortIsps(this.props.location.isps, timeWindow, sortBy);

    return isps.slice(0, this.state.itemsVisible);
  }

  render() {
    const { i18n, location, activeIsp, timeWindow } = this.props;
    const showCount = Math.min(5, this.props.location.isps.length - this.state.itemsVisible);

    return (<section className="leaderboard">
              <header>
                <q-grid fluid>
                  <q-col md-size="6" className="score-keys">
                    <div className="compare-providers">
                      {i18n.t('compare')} <span className="compare-location"><Location location={location.location} hideCountry={true}/></span>
                    </div>
                  </q-col>
                  <q-col md-size="6" className="score-sort">
                    <label>{ i18n.t('sort_by') }</label>
                    <strong onClick={() => this.setSort('connection_score')}>{ i18n.t('score') }</strong>
                    <q-switch size="sm" state={this.state.sortBy === 'connection_score' ? 'off' : 'on'} shape="circle" type="blank" ref={toggle => this.toggle = toggle} onClick={() => this.handleSort()} />
                    <strong onClick={() => this.setSort('population')}>{ i18n.t('population') }</strong>
                  </q-col>
                </q-grid>
              </header>
              <div className="listings">
                <table>
                  <IspList isps={this.filterIsps()} activeIsp={activeIsp} timeWindow={timeWindow} />
                </table>
              </div>

              {this.state.itemsVisible < location.isps.length &&
                <div className="text-center">
                  <q-button onClick={() => this.handleLoadMore()}>{i18n.replace('load_more', { '!count': showCount })}</q-button>
                </div>}
                <div>
                  <em className="disclaimer">{ i18n.t('percentage_disclaimer') }</em>
                </div>
            </section>);
  }
}

export default localize('pages.scores.leaderboard')(LeaderBoardBare);



// WEBPACK FOOTER //
// ./src/components/Leaderboard/index.js